<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="row">
            <div class="columns small-12 medium-4">
              <div
                class="panel rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom4 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>

          <div class="row">
            <div class="columns small-12 medium-4">
              <div class="panel small-only-text-center clearfix" [ngClass]="getPanelClass()">
                <div class="small-only-text-center">
                  <div
                    class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>

                <div
                  class="panel rs-inline-block rs-wd-s19 rs-h-s2 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-inline-block rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
              <div class="panel show-for-medium-up jsrs-clickable clearfix" style="cursor: pointer">
                <div
                  class="panel rs-wd-s31 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
            <div class="columns small-12 medium-8">
              <div class="rs-flex-row">
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel hide-for-medium-up clearfix">
            <div
              class="panel rs-wd-s31 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <hr class="rs-margin-top2 rs-padding-bottom2-m" />
          <div class="row">
            <div class="columns small-12 medium-4">
              <div class="panel small-only-text-center clearfix" [ngClass]="getPanelClass()">
                <div class="small-only-text-center">
                  <div
                    class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>

                <div
                  class="panel rs-inline-block rs-wd-s19 rs-h-s2 rs-no-padding rs-no-margin rs-bg-grey4 rs-anim-loading"
                ></div>
                <div
                  class="panel rs-inline-block rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
              <div class="panel show-for-medium-up jsrs-clickable clearfix" style="cursor: pointer">
                <div
                  class="panel rs-wd-s31 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
            <div class="columns small-12 medium-8">
              <div class="rs-flex-row">
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s19 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div
                      class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div class="rs-flex-row rs-flex-middle">
                        <div class="rs-flex-columns">
                          <div class="text-center rs-pos-rel">
                            <div
                              class="panel rs-inline-block rs-wd-s14 rs-h-s14 rs-radius-circle rs-margin-bottom1 rs-bg-grey4 rs-anim-loading text-center"
                            ></div>
                            <div
                              class="panel rs-inline-block rs-wd-s12 rs-h-s12 rs-radius-circle rs-margin-bottom1 rs-bg-grey1 rs-pos-tc rs-margin-top1"
                            ></div>
                          </div>
                        </div>
                        <div class="rs-flex-columns rs-flex-grow">
                          <div
                            class="panel rs-wd-s5 rs-wd-m6 rs-h-s3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                          ></div>
                          <div
                            class="panel rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s13 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel hide-for-medium-up clearfix">
            <div
              class="panel rs-wd-s31 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <hr class="rs-margin-top2 rs-padding-bottom2-m" />

          <div class="row">
            <div class="columns small-12 medium-4">
              <div class="panel clearfix" [ngClass]="getPanelClass()">
                <div
                  class="panel rs-wd-s23 rs-wd-m25 rs-h-s2 rs-h-m4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
            <div class="columns small-12 medium-8">
              <div class="rs-flex-row">
                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel rs-panel-clickable clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>

                <div class="rs-flex-columns small-12 medium-6">
                  <div class="panel rs-panel-clickable clearfix">
                    <div
                      class="panel rs-wd-s25 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                    <div class="rs-panel-collapse rs-bg-grey1 clearfix">
                      <div
                        class="panel rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="rs-me"></div>
          <div class="text-center medium-text-right">
            <div
              class="panel rs-inline-block rs-wd-s18 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
